#
# The set of dialogs helpers to present all kinds of modal windows
#
class @Dialogs

  @presentModal: (options, fn) ->
    modal         = $("#main-modal")
    header        = modal.find(".modal-header")
    body          = modal.find(".modal-body")
    footer        = modal.find(".modal-footer")
    closeButton   = footer.find(".btn-close")
    primaryButton = footer.find(".btn-primary")
    dangerButton  = footer.find(".btn-danger")
    supportButton = footer.find(".btn-support")

    if options.header
      header.find("h3").html(options.header).show()
    else
      header.hide()

    if options.body
      body.html(options.body).show()
    else
      body.hide()

    closeButton.html(options.closeLabel || t('buttons.close'))

    done = (name, fn) ->
      fn?(name, -> modal.modal("hide"))
      modal.modal("hide") unless options.dontHideModal
      return false

    adjustButton = (button, name, label, fn) ->
      if label
        button.html(label).show()
        button.unbind().click(-> done(name, fn))
      else
        button.unbind().hide()

    adjustButton(primaryButton, "primary", options.primaryLabel, fn)
    adjustButton(dangerButton, "danger", options.dangerLabel, fn)

    if options.supportButtonLabel && options.supportButtonFn
      supportButtonFn = (e) ->
        e.preventDefault()
        e.stopPropagation()
        options.supportButtonFn(e)
      supportButton.text(options.supportButtonLabel).off("click").on("click", supportButtonFn).show()
    else
      supportButton.hide()

    modal.off("shown")
    modal.off("hide")
    modal.off("hidden")
    modal.off("keypress")

    modal.on "keypress", "input", (e) ->
      if e.which == 13
        done("return", fn)

    modalObject = _.bind(modal.modal, modal)

    modalObject("show")

    modalObject.adjustPrimaryButton = (label, fn) -> adjustButton(primaryButton, "primary", label, fn)

    modalObject

  @presentUpdateableStatusModal: (initialMessage, options, fn) ->
    modalOptions =
      body:          initialMessage
      closeLabel:    t("buttons.cancel")
      dontHideModal: true
      onShown:       options.onShown

    $modal = $("#main-modal")
    modal = Dialogs.presentModal(modalOptions)

    isClosed = false

    updater = {
      show: -> $modal.modal("show")
      hide: -> $modal.modal("hide")
      message: (html) -> $(".modal-body", $modal).html(html)
      adjustPrimaryButton: _.bind(modal.adjustPrimaryButton, modal)
      isVisible: -> $modal.is(":visible")
      isClosed: -> isClosed
    }

    $modal.on( "shown",  -> fn?(updater)    )
    $modal.on( "hide",   -> isClosed = true )

    updater

  @presentAlertModal: (message, fn, header) ->
    modalOptions =
      body:        message
      header:      header
      closeLabel:  t("phrases.okay")

    Dialogs.presentModal modalOptions, (selection) ->
      fn() if fn

    return false

  @presentErrorModal: (message) ->
    modalOptions =
      body:        Dialogs.errorMessage(message)
      closeLabel:  t("phrases.okay")

    Dialogs.presentModal modalOptions, (selection) ->
      fn() if fn

    return false

  @presentRemovalModal: (question, object, destroyType, fn) ->
    destroyType = "remove" if !destroyType

    modalOptions =
      header:      t("modals.#{ destroyType }.header", object: object)
      body:        question
      closeLabel:  t("modals.#{ destroyType }.closeLabel")
      dangerLabel: t("modals.#{ destroyType }.dangerLabel", object: object)

    Dialogs.presentModal modalOptions, (selection) ->
      fn() if selection == "danger"

    return false

  @presentYesNoModal: (question, options, href) ->
    options   ||= {}
    noPhrase    = options.noPhrase  || t("phrases.no")
    yesPhrase   = options.yesPhrase || t("phrases.yes")
    yesType     = options.yesType   || "danger"
    yesClass    = if yesType == "danger" then "dangerous-button" else ""

    modal = $("""
      <div class="modal hide fade" id="main-modal">
        <div class="modal-body">
        </div>

        <div class="modal-footer">
          <a class="diminished-button button btn btn-close no-button" data-dismiss="modal" href="#">#{t 'phrases.no'}</a>
          <a class="#{ yesClass } button btn btn-#{ yesType } yes-button" href="#"></a>
        </div>
      </div>
    """)

    $( ".no-button", modal).text( noPhrase)
    $(".yes-button", modal).text(yesPhrase)

    modal.find(".modal-body").html(question)

    if typeof href == "function"
      modal.find(".yes-button").on "click", ->
        Dialogs.hideAllModals()
        href()
        return false
    else
      modal.find(".yes-button").attr(href: href)

    modal.modal("show")

  @errorMessage: (message) ->
    $("<div></div>").addClass("red-text")
      .append($("<i></i>").addClass("fa fa-exclamation-triangle red-text"))
      .append($("<span></span>").css("float", "right").css("width", "90%").text(message))

  @hideAllModals: ->
    $(".modal").modal("hide")
